<template>
    <f7-page name="manual">
        <!-- Navbar -->
        <f7-navbar title="Kundenliste" back-link>
            <f7-subnavbar :inner="false">
                <f7-searchbar
                    placeholder="suchen"
                    search-container=".virtual-list"
                    search-item="li"
                    search-in=".item-title"
                    :disable-button="false"
                    @searchbar:search="setSearchString"
                ></f7-searchbar>
            </f7-subnavbar>
        </f7-navbar>

        <!-- Customer List (favorites) -->
        <f7-list v-if="searchString === ''" media-list style="margin-bottom: 0px">
            <ul>
                <f7-list-item title="Favoriten" group-title></f7-list-item>
                <f7-list-item
                    v-for="(item, index) in favorites"
                    :key="index"
                    :title="item.name1"
                    :subtitle="item.address1 + ', ' + item.postalcode + ' ' + item.place"
                    :style="`top: ${vlData.topPosition}px`"
                >
                </f7-list-item>
            </ul>
        </f7-list>

        <!-- Customer list (all) -->
        <f7-list
            media-list
            virtual-list
            :virtual-list-params="{
                items,
                searchAll,
                renderExternal,
                height: $theme.ios ? 69 : $theme.md ? 73 : 73,
            }"
        >
            <ul>
                <f7-list-item title="Alle Shops" group-title></f7-list-item>
                <f7-list-item
                    v-for="(item, index) in vlData.items"
                    :key="index"
                    :title="item.name1"
                    :subtitle="item.address1 + ', ' + item.postalcode + ' ' + item.place"
                    :style="`top: ${vlData.topPosition}px`"
                >
                </f7-list-item>
            </ul>
        </f7-list>
        <!-- <f7-button fill large @click="$f7router.navigate('/selectDeliveryDate/')">Weiter</f7-button> -->
    </f7-page>
</template>
<script>
const Entities = require("html-entities").AllHtmlEntities;
const entities = new Entities();

export default {
    data() {
        return {
            items: [],
            favorites: [],
            vlData: {
                items: [],
            },
            searchString: "",
        };
    },

    props: [""],

    methods: {
        searchAll(query, items) {
            const found = [];
            for (let i = 0; i < items.length; i += 1) {
                if (
                    items[i].name1.toLowerCase().indexOf(query.toLowerCase()) >= 0 ||
                    items[i].place.toLowerCase().indexOf(query.toLowerCase()) >= 0 ||
                    query.trim() === ""
                )
                    found.push(i);
            }
            return found;
        },
        renderExternal(vl, vlData) {
            this.vlData = vlData;
        },
        setSearchString(searchbar, query) {
            this.searchString = query;
        },
    },

    beforeMount() {
        // Load all customers
        console.log("Sorting responsible person...");
        const _this = this;
        this.items = this.$root.$data.customers;

        // Load & sort favorites
        this.favorites = this.items.filter((customer) => customer.responsible === this.$root.$data.responsible);
        this.favorites = this.favorites.sort((a, b) => {
            if (a.name1 < b.name1) {
                return -1;
            } else {
                return 1;
            }
        });
    },

    computed: {},
};
</script>

<style>
.list {
    margin-top: 0px;
}
.button {
    margin: 80px 10px 0px 10px;
}
</style>
